import {observer} from "mobx-react-lite";
import {ReactNode} from "react";
import {sessionStore} from "./session.store";


export const IsAuthProtected = observer(({children, alt = null}: {children: ReactNode, alt?: ReactNode }) => {

    const {isAuth} = sessionStore

    // if (!isAuth) return alt ?? null

    return <>{!isAuth ? alt : children}</>
})